module.exports = __webpack_public_path__ + "937371f2b269c6d58edba2f47c9216ea.mp4";